import { contactSmsConsentFilterValues } from '@/services/domain/contact/types'
import type { PaginationUrlFilterType } from '@/services/tables/types'

export const contactSmsConsentFilterName = 'smsConsent'

const isInOperationValue = (value: unknown): value is { in: unknown[] } =>
  typeof value === 'object' && value !== null && 'in' in value && Array.isArray(value.in)

export const isAllSmsConsentFilterValue = (value: unknown) => {
  if (!isInOperationValue(value)) {
    return false
  }

  const selected = value.in

  return (
    selected.length === contactSmsConsentFilterValues.length &&
    contactSmsConsentFilterValues.every((item) => selected.includes(item))
  )
}

export const removeAllSmsConsentFilter = (filters: PaginationUrlFilterType): PaginationUrlFilterType =>
  filters.flatMap((filter) => {
    if (!isAllSmsConsentFilterValue(filter[contactSmsConsentFilterName])) {
      return [filter]
    }

    const { [contactSmsConsentFilterName]: _, ...rest } = filter

    return Object.keys(rest).length ? [rest] : []
  })
